<template>
    <div class="full-contact-map-wrapper map-wrapper">
        <gmap-map
                :center="{lat:41.6053072, lng:0.6097705}"
                :zoom="15"
                map-type-id="roadmap"
                style="width: 100%; height: 20em">
            <gmap-marker
                    :position="{lat:41.604582, lng:0.614124}" :clickable="false"
                    :draggable="false"/>
        </gmap-map>
        <div class="absolute-contact-info">
            <div class="container">
                <div class="content clearfix">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <div class="item">
                                <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                                Avinguda del Exercit 33, Lleida
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-3">
                            <div class="item">
                                <font-awesome-icon style="margin-right: 0.5em;" icon="phone"/>
                                973 87 00 00
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-3">
                            <div class="pull-right xs-pull-left">
                                <div class="item more-pl">
                                    <font-awesome-icon style="margin-right: 0.5em;" icon="envelope-open"/>
                                    <a href="#" class="email">info@volarooms.es</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'contactMap'
    }
</script>
<style scoped>
    .email {
        color: #8ac6c4 !important;
    }

    .email:hover {
        color: #8d9499 !important;
    }
</style>